import { Component } from "react";
import { connect } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";

import {
	SET_POST_DESCRIPTION_ERROR,
	SET_POST_TITLE_ERROR,
	SET_POST_DESCRIPTION_FR,
	SET_POST_TITLE_FR,
	SET_POST_PROMOTION_FR,
	SET_POST_PROMOTION_ERROR
} from "actions/types";

class Step3 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		const { dispatch, description, title, isPromotionType, promotion } =
			this.props;

		let success = true;
		if (!title) {
			dispatch({
				type: SET_POST_TITLE_ERROR
			});
			success = false;
		}
		if (!description) {
			dispatch({
				type: SET_POST_DESCRIPTION_ERROR
			});
			success = false;
		}

		if (isPromotionType && !promotion) {
			dispatch({
				type: SET_POST_PROMOTION_ERROR
			});
			success = false;
		}

		return success;
	}

	render() {
		const {
			dispatch,
			description,
			descriptionErrorMsg,
			title,
			titleErrorMsg,
			promotion,
			isPromotionType,
			promotionErrorMsg
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<MDInput
						label="Titre *"
						id="title-fr"
						fullWidth
						error={!!titleErrorMsg}
						helperText={titleErrorMsg}
						value={title || ""}
						onChange={e =>
							dispatch({
								type: SET_POST_TITLE_FR,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Description *"
						id="description-fr"
						fullWidth
						multiline
						rows={5}
						error={!!descriptionErrorMsg}
						helperText={descriptionErrorMsg}
						value={description || ""}
						onChange={e =>
							dispatch({
								type: SET_POST_DESCRIPTION_FR,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label={"Promotion" + (isPromotionType ? " *" : "")}
						id="promotion"
						fullWidth
						error={!!promotionErrorMsg}
						helperText={promotionErrorMsg}
						value={promotion || ""}
						onChange={e =>
							dispatch({
								type: SET_POST_PROMOTION_FR,
								value: e.target.value
							})
						}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		description,
		descriptionErrorMsg,
		title,
		titleErrorMsg,
		promotion,
		isPromotionType,
		promotionErrorMsg
	} = state.eventReducer;

	return {
		description,
		descriptionErrorMsg,
		title,
		titleErrorMsg,
		promotion,
		isPromotionType,
		promotionErrorMsg
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step3
);
